module.exports = __webpack_public_path__ + "static/media/spades-queen.6640295d.png";